import { useIntersectionObserver } from "@/hooks";
import styles from "@/styles/InfinityScrollList.module.scss";
import classnames from "classnames";
import { useEffect, useRef, useState } from "react";

export default function InfinityScrollList({
  loadMore,
  fetchMore,
  observerOpts,
  children,
}) {
  const [loadingMore, setLoadingMore] = useState(false);
  const loader = useRef();
  // TODO: optionは調整する
  observerOpts = observerOpts ?? {
    root: null,
    rootMargin: "10px",
    threshold: 0.25,
  };
  const intersect = useIntersectionObserver(loader, observerOpts);

  useEffect(() => {
    const func = async () => {
      if (loadMore && intersect && !loadingMore) {
        setLoadingMore(true);
        await fetchMore();
        setLoadingMore(false);
      }
    };
    func();
  }, [loadMore, intersect, loadingMore]);

  return (
    <>
      <div className={styles.list}>{children}</div>
      <div
        ref={loader}
        className={classnames(styles.loader, { [styles.show]: loadMore })}
      >
        <div className={styles.spinner}>
          <div className={styles.bounce1}></div>
          <div className={styles.bounce2}></div>
          <div className={styles.bounce3}></div>
        </div>
      </div>
    </>
  );
}
